export default {
  methods: {
    getCountryNavLinks() {
      return [
        { nameKey: 'common.suppliers', route: 'routes.rentals.country' },
        { nameKey: 'common.cities', route: 'routes.locations.country' },
        { nameKey: 'common.airports', route: 'routes.airports.country' }
      ]
    },
    getInfoNavLinks () {
      const rentprotectionKey = this.$t('rent.protection.configure.terms.link').replace(/\./g, '')

      const baseLinks = [
        { nameKey: 'menu.about', route: 'routes.info.about' },
        { nameKey: 'menu.requirements', route: 'routes.info.requirements' },
        { nameKey: 'booking.lowratenps.whatyoumisspayment', route: 'routes.info.payment' },
        { nameKey: 'menu.registercompany', route: 'routes.info.registercompany', langs: ['pt-br'] },
        { nameKey: 'contact.pgtitle', route: 'routes.info.contact' },
        { nameKey: 'menu.privacyPolicy', route: 'routes.info.privacy' },
        { nameKey: 'privacy.cookiesPolicy', route: 'routes.info.cookies' },
        { nameKey: 'payment.terms', route: 'routes.info.terms-conditions' },
        { nameKey: rentprotectionKey, route: 'routes.info.regulamento-rent-protection' },
        { nameKey: 'menu.code-conduct', route: 'routes.info.code-conduct' },
        { nameKey: 'menu.anti-discrimination-policy', route: 'routes.info.anti-discrimination-policy' },
        { nameKey: 'common.backToHome', route: 'routes.home' }
      ]

      if (this.$store.getters.getLocale === 'es-mx') {
        baseLinks.splice(baseLinks.length - 1, 0, { nameKey: 'Términos y condiciones promocionales', route: 'routes.info.promotional-terms-conditions' })
      }

      return baseLinks
    }
  }
}
